export default __webpack_public_path__ + "static/media/ticket.47e795c3.svg";